/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

export class SettingsMenuTypes {
    static MENU = 'menu';

    static SUB_MENU = 'submenu';
}
